import React from 'react';
import { useField, connect } from 'formik';

import { FormLabel as Label, Tags } from '~ui-kit';
import FieldContextFeeder from '../components/FieldContextFeeder';

const TagField = props => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  const name = props.id || props.name;

  const localProps = {
    ...field,
    ...props,
    error,
    // https://github.com/formium/formik/issues/789
    onChange: option => {
      setFieldValue(name, option);
      if (props.onChange) props.onChange(option);
    },
  };

  return (
    <div>
      <Label
        htmlFor={props.id || props.name}
        required={props.required}
        info={props.info}
      >
        {props.label}
      </Label>
      <Tags {...localProps} />
    </div>
  );
};

export default FieldContextFeeder(connect(TagField));
